const financial = require('financial');

const monitor = require("@/common/js/monitor/monitor");

//
const calculateTotalLoan = (carPriceDownPayment, additionalProductDownPayment = 0, carDiscount = 0, additionalProductDiscount = 0) => {
  //console.log(carPriceDownPayment);
  //console.log(additionalProductDownPayment);
  //console.log(carDiscount);
  //console.log(additionalProductDiscount);
  // 贷款总金额 = (当前贷款金额 - 汽车贴息) + (附加品贷款金额 - 附加品贴息)
  //console.log(carPriceDownPayment, "==carPriceDownPayment")
  //console.log(carDiscount, "==carDiscount")
  //console.log(additionalProductDownPayment,"==additionalProductDownPayment")
  //console.log(additionalProductDiscount,"==additionalProductDiscount==")
  let totalLoan = (carPriceDownPayment - carDiscount) + (additionalProductDownPayment - additionalProductDiscount);
  return -totalLoan;
}

//PMT 等额本息计算  月供公式
/**
 * 计算等额本息贷款每期还款金额
 * @param {number} rate 年利率（百分比）
 * @param {number} nper 总期数（例如，30年期贷款就是360期）
 * @param {number} pv 贷款本金总额
 * @param {number} fv （可选）期望的未来值或最后的现金余额，即在最后一期偿还贷款后希望剩余的现金金额。如果省略该参数，假定其为0（即假定贷款在最后一期完全偿还）。
 * @param {number} type （可选）表示还款时间的数字。0或省略表示期末（每期结束时）偿还，1表示期初（每期开始时）偿还。
 * @return {number} 每期还款金额
 */
const PMT = (rate, nper, pv, fv = 0, type = 0) => {
  rate = rate / 100 / 12; // 将年化利率转换为每月利率
  if (rate === 0) return -(pv + fv) / nper;
  var pvif = Math.pow(1 + rate, nper); // 计算(1 + rate)^nper
  var pmt = rate / (pvif - 1) * -(pv * pvif + fv); // 计算PMT值，注意贷款本金总额为负数
  if (type === 1) pmt /= (1 + rate); // 如果type=1，即每期支付在期初，需要进行此步骤
  return pmt;
}

const pmt2 = (rate, nper, pv, fv = 0, type = 0) =>{
  if (rate === 0) {
    // 如果利率为0，支付额公式简化为：
    return -(pv + fv) / nper;
  } else {
    let pmtValue = (rate * (pv * Math.pow(1 + rate, nper) + fv)) / ((1 + rate * type) * (Math.pow(1 + rate, nper) - 1));
    return -pmtValue;
  }
}

//客户利率公式
//客户利率 = 贷款总金额 * 月供 / 贷款总金额 * 12 * 100
/**
 * * 计算年利率并格式化为百分比
 *  * @param {number} nper - 总付款期数
 *  * @param {number} pmt - 每期付款金额(如果为0,则表示偿还本金)
 *  * @param {number} pv - 现值
 *  * @param {number} [fv=0] - 未来值或余值(可选,默认为0)
 *  * @param {boolean} [type=0] - 指定付款是在期初还是期末(可选,0表示期末,1表示期初)
 *  * @param {number} [guess=0.1] - 估算利率值(可选,默认为0.1)
 *  * @returns {string} 格式化为百分比的年利率
 */
const RATE = (nper, pmt, pv, fv, type, guess) => {
  // console.log(pmt);
  // console.log(pv);
  // console.log((financial.rate(24, pmt, pv, 0) * 12).toFixed(2), "==financial.rate(nper, pmt.toFixed(2), pv,0)==")
  return (financial.rate(nper, pmt, pv, 0) * 12).toFixed(2);

  // // Set default values for fv and type
  // fv = fv === undefined ? 0 : fv;
  // type = type === undefined ? 0 : type;
  //
  // // Set an arbitrary guess if none is provided
  // guess = guess === undefined ? 0.1 : guess;
  //
  // // The maximum number of iterations
  // var maxIter = 100;
  // // The minimum change between iterations required to continue
  // var epsilon = 1e-10;
  //
  // var rate = guess;
  // var y, y0, y1, x0, x1 = 0;
  // var i = 0;
  // while (i < maxIter) {
  //     y = pv * (1 + rate * type) - pmt * (1 + rate * nper) / rate + fv;
  //     y0 = pv * type + pmt * (nper - 1) / rate^2 - fv * rate;
  //     y1 = y0 + pv + pmt / rate^2 + fv * nper;
  //
  //     if (Math.abs(y / y1) < epsilon) {
  //         break;
  //     }
  //
  //     rate = rate - y / y1;
  //     i++;
  // }
  //
  // return rate;
}

// 附加品首付
// 附加品金额>20万，首付为30% 附加品金额<=20万，首付为20%
const calculateDownPaymentForAncillaryProducts = (ancillaryProductsAmount) => {
  if (Number(ancillaryProductsAmount) > 200000) {
    return Number(ancillaryProductsAmount) * (1 - .3);
    //return Number(ancillaryProductsAmount) * (.3);
  } else {
    return Number(ancillaryProductsAmount) * (1 - .2);
    //return Number(ancillaryProductsAmount) * (.2);
  }
}

/**
 * Function to calculate the IRR (Internal Rate of Return)
 * @param {number[]} cashFlows - Array of cash flows, where the first element is the initial investment (negative) and the subsequent elements are the returns (positive).
 * @param {number} guess - Initial guess for the IRR.
 * @returns {number} - The IRR as a decimal.
 */
function IRR(cashFlows, guess = 0.1) {
  const maxIterations = 10000; // 增加最大迭代次数
  const precision = 1e-7;

  let rate = guess;

  for (let iter = 0; iter < maxIterations; iter++) {
    let npv = 0;
    let derivative = 0;

    for (let t = 0; t < cashFlows.length; t++) {
      npv += cashFlows[t] / Math.pow(1 + rate, t);
      derivative -= t * cashFlows[t] / Math.pow(1 + rate, t + 1);
    }

    const newRate = rate - npv / derivative;

    if (Math.abs(newRate - rate) < precision) {
      return newRate;
    }

    rate = newRate;
  }

  throw new Error('IRR did not converge');
}

/**
 * Function to calculate the maximum loan amount
 * @param {number} subsidyAmount - The subsidy amount.
 * @param {number} rate - The interest rate as a percentage (e.g., 5 for 5%).
 * @param {number} term - The term in months.
 * @returns {number} - The maximum loan amount.
 */
function maxLoanAmount(subsidyAmount, rate, term) {
  // Generate cash flows for IRR calculation
  const monthlyRate = rate / 100 / 12;
  const cashFlows = [-10000, ...Array(term).fill(10000 / term * (1 + monthlyRate))];

  try {
    const irrRate = IRR(cashFlows);
    const monthlyIRR = irrRate / 12;
    const denominator = (10000 - (10000 * monthlyIRR)) / 10000;
    return subsidyAmount / denominator;
  } catch (error) {
    console.error('Error calculating IRR:', error.message);
    return null;
  }
}

function PV(rate, nper, pmt, fv = 0, type = 0) {
  if (rate === 0) {
    // 如果利率为0，现值公式简化为：
    return -pmt * nper - fv;
  } else {
    let pvValue = -pmt * (1 + rate * type) * (1 - Math.pow(1 + rate, -nper)) / rate - fv / Math.pow(1 + rate, nper);
    return pvValue;
  }
}

// 数据监测====================================

/**
 * 示例
 *   clickEvent ({
 *       event_en:'test',
 *       event_cn: "测试"
 *     });
 *
 * */

const clickMonitor = (data) => {
  console.log("监测点击事件——" + JSON.stringify(data));
  monitor.clickEvent(data)
}

module.exports = {
  calculateTotalLoan,
  PMT,
  RATE,
  calculateDownPaymentForAncillaryProducts,
  clickMonitor,
  maxLoanAmount,
  PV
}
